import axios from "../../axios";

const state = {
  remaining: {
    months: 0,
    students_count: 0,
  },
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getReportRemainingMonths({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`reports/remaining-months`, { params: param })
        .then((response) => {
          commit("SET_REPORT_REMAINING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  // eslint-disable-next-line no-unused-vars
  SET_REPORT_REMAINING(state, data) {
    state.remaining = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
